import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@adsk/alloy-react-divider';
import theme from '@adsk/alloy-react-theme';
const ProjectListCategoryTitle = _ref => {
  let {
    item
  } = _ref;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: [{
      padding: '16px 16px 0'
    }]
  }, /*#__PURE__*/React.createElement(_StyledH, {
    $_css2: [theme.typography.heading4, {
      color: theme.colors.charcoal700,
      paddingBottom: 5,
      margin: 0
    }]
  }, item.title), /*#__PURE__*/React.createElement(Divider, null));
};
ProjectListCategoryTitle.displayName = 'ProjectListCategoryTitle';
ProjectListCategoryTitle.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired
  })
};
export default ProjectListCategoryTitle;
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), p => p.$_css);
var _StyledH = _styled2("h4").withConfig({
  displayName: "ProjectListCategoryTitle___StyledH",
  componentId: "sc-ekya3c-0"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=ProjectListCategoryTitle.js.map